export enum AccountRecovery {
  ACCOUNT_RECOVERY_INIT = '@account_recovery/ACCOUNT_RECOVERY_INIT',
  CREATE_ACCOUNT_RECOVERY_REQUEST = '@account_recovery/CREATE_ACCOUNT_RECOVERY_REQUEST',
  CREATE_ACCOUNT_RECOVERY_SUCCESS = '@account_recovery/CREATE_ACCOUNT_RECOVERY_SUCCESS',
  CREATE_ACCOUNT_RECOVERY_FAIL = '@account_recovery/CREATE_ACCOUNT_RECOVERY_FAIL',

  EMAIL_VERIFY_REQUEST = '@account_recovery/EMAIL_VERIFY_REQUEST',
  EMAIL_VERIFY_SUCCESS = '@account_recovery/EMAIL_VERIFY_SUCCESS',
  EMAIL_VERIFY_FAIL = '@account_recovery/EMAIL_VERIFY_FAIL',

  ADD_IDENTITY_REQUEST = '@account_recovery/ADD_IDENTITY_REQUEST',
  ADD_IDENTITY_SUCCESS = '@account_recovery/ADD_IDENTITY_SUCCESS',
  ADD_IDENTITY_FAIL = '@account_recovery/ADD_IDENTITY_FAIL',

  VERIFY_IDENTITY_REQUEST = '@account_recovery/VERIFY_IDENTITY_REQUEST',
  VERIFY_IDENTITY_SUCCESS = '@account_recovery/VERIFY_IDENTITY_SUCCESS',
  VERIFY_IDENTITY_FAIL = '@account_recovery/VERIFY_IDENTITY_FAIL',

  RESEND_EMAIL_VERIFICATION_CODE_REQUEST = '@account_recovery/RESEND_EMAIL_VERIFICATION_CODE_REQUEST',
  RESEND_EMAIL_VERIFICATION_CODE_SUCCESS = '@account_recovery/RESEND_EMAIL_VERIFICATION_CODE_SUCCESS',
  RESEND_EMAIL_VERIFICATION_CODE_FAIL = '@account_recovery/RESEND_EMAIL_VERIFICATION_CODE_FAIL',

  RESEND_IDENTITY_VERIFICATION_CODE_REQUEST = '@account_recovery/RESEND_IDENTITY_VERIFICATION_CODE_REQUEST',
  RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS = '@account_recovery/RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS',
  RESEND_IDENTITY_VERIFICATION_CODE_FAIL = '@account_recovery/RESEND_IDENTITY_VERIFICATION_CODE_FAIL',

  ACCOUNT_RECOVERY_CLEAR = '@account_recovery/ACCOUNT_RECOVERY_CLEAR',
}
